var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#005DA8",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.414 20.9708L21.556 10.8288L20.142 9.41479L10 19.5568V20.9708H11.414ZM12.243 22.9708H8V18.7278L19.435 7.29279C19.6225 7.10532 19.8768 7 20.142 7C20.4072 7 20.6615 7.10532 20.849 7.29279L23.678 10.1218C23.8655 10.3093 23.9708 10.5636 23.9708 10.8288C23.9708 11.094 23.8655 11.3483 23.678 11.5358L12.243 22.9708ZM8 24.9708H26V26.9708H8V24.9708Z",
    fill: "#005DA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.09aaa57f3f330ec5fa0203ce220079ce.svg";
export { ForwardRef as ReactComponent };